import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)] flex flex-col" }
const _hoisted_2 = { class: "md:sticky relative top-0 z-10 bg-white px-6 py-4 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)] flex lg:justify-between lg:items-center w-full lg:flex-row flex-col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "View Interventions", -1)
const _hoisted_4 = { class: "text-lg font-medium md:text-2xl text-neutral-600" }
const _hoisted_5 = { class: "block font-semibold md:inline-block text-neutral-900" }
const _hoisted_6 = { class: "lg:w-[600px] w-full lg:mt-0 mt-6" }
const _hoisted_7 = { class: "flex flex-wrap items-end lg:justify-end lg:space-x-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "whitespace-nowrap" }
const _hoisted_10 = { class: "flex-1 w-full px-6 mt-6 mb-6" }

import { ref, Component } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import InterventionViewPage from "./Components/InterventionViewPage.vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import { useRouter, useRoute } from "vue-router";
import { SelectInterface } from "@/interfaces/pages/BasePageInterface";
import { InterventionType } from "@/views/enums/InterventionType";
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";
import SocialWorkIcon from "@/components/icons/socialWorkIcon.vue";
import MentalHealthIcon from "@/components/icons/mentalHealthIcon.vue";
import DevelopmentalPediaIcon from "@/components/icons/developmentalPediaIcon.vue";
import LegalIcon from "@/components/icons/legalIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const patientId = ref<number>(route.params.patient);
const caseId = ref<number | null>(route.params.case);

const patient = ref<string>('');
const interventionTypes = ref<SelectInterface[]>([]);

const redirectBack = () => {
	let url = { path: `/intervention/search` }

	if(caseId?.value) {
		url = { path: `/patient/${patientId.value}/cases/${caseId.value}/edit` }
	}

	router.push(url); 
};

const createIntervention = (intervention:number):void => {
	let url = `/patient/${patientId.value}/intervention/${intervention}/create`

	if(caseId?.value) {
		url = `/patient/${patientId.value}/cases/${caseId.value}/intervention/${intervention}/create`
	}
	
	router.replace(url);
};

const fetchInterventionIcon = (intervention:number): Component|null => {
    switch (intervention) {
        case InterventionType.SOCIAL_WORK:
            // return  "/assets/icon/intervention/ic-social-work.svg"
			return  SocialWorkIcon;
        case InterventionType.MENTAL_HEALTH:
            // return  "/assets/icon/intervention/ic-mental-health.svg"
			return  MentalHealthIcon
        case InterventionType.DEVELOPMENT_PEDIA:
            // return  "/assets/icon/intervention/ic-developmental-pedia.svg"
			return  DevelopmentalPediaIcon
        case InterventionType.LEGAL:
            // return  "/assets/icon/intervention/ic-legal.svg"
			return  LegalIcon
        default:
			return null;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectBack()))
            }, [
              _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition pl-0" }, {
                default: _withCtx(() => [
                  _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _createElementVNode("p", _hoisted_4, [
              _createTextVNode("Patient's Name: "),
              _createElementVNode("span", _hoisted_5, _toDisplayString(patient.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interventionTypes.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (createIntervention(item.id)),
                  class: "col-span-1 cursor-pointer md:justify-center md:w-fit w-full flex md:py-[7px] py-[14px] px-4 rounded bg-primary-800 hover:bg-primary-700 font-semibold text-xs text-white transition btn my-1 lg:mr-0 md:mr-2"
                }, [
                  (fetchInterventionIcon(item.id))
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(fetchInterventionIcon(item.id)), {
                        key: 0,
                        class: "object-contain w-4 h-4 mr-1 -ml-2 icon"
                      }))
                    : (_openBlock(), _createBlock(_unref(PlusIcon), {
                        key: 1,
                        class: "w-4 h-4 stroke-[3px] -ml-2 mr-1 icon"
                      })),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.label), 1)
                ], 8, _hoisted_8))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(InterventionViewPage, {
            "onUpdate:patientName": _cache[1] || (_cache[1] = (value) => (patient.value = value)),
            "onUpdate:interventionType": _cache[2] || (_cache[2] = (value) => (interventionTypes.value = value))
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})